import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import {
  useHomeAddStaticSectionMutation,
  useHomeUPdateStaticSectionMutation,
  useHomeListStaticSectionQuery,
} from "../../../../Services/HomeAPI";

function AddStockWithSubHeading() {
  const [formData, setFormData] = useState({
    main_heading: "",
    sub_heading: "",
    description: "",
    main_image: null,
    sections: Array(4).fill({ logo: null, heading: "", content: "" }),
  });

  const [updateStock, { isLoading: updateLoading }] =
    useHomeUPdateStaticSectionMutation();
  const [addStock, { isLoading: addLoading }] =
    useHomeAddStaticSectionMutation();
  const {
    data: contentDetail,
    isLoading: loadingContent,
    error,
    refetch: refetchContentDetail,
  } = useHomeListStaticSectionQuery();

  useEffect(() => {
    refetchContentDetail();
  }, [refetchContentDetail]);

  useEffect(() => {
    if (contentDetail?.data?.length > 0) {
      const existingData = contentDetail.data[0];

      setFormData({
        main_heading: existingData.main_heading || "",
        sub_heading: existingData.sub_heading || "",
        description: existingData.description || "",
        main_image: existingData.main_image || null,
        sections: [
          {
            logo: existingData.logo_one || null,
            heading: existingData.log_heading_one || "",
            content: existingData.content_one || "",
          },
          {
            logo: existingData.logo_two || null,
            heading: existingData.log_heading_two || "",
            content: existingData.content_two || "",
          },
          {
            logo: existingData.logo_three || null,
            heading: existingData.log_heading_three || "",
            content: existingData.content_three || "",
          },
          {
            logo: existingData.logo_four || null,
            heading: existingData.log_heading_four || "",
            content: existingData.content_four || "",
          },
        ],
      });
    }
  }, [contentDetail]);

  // const handleChange = (e) => {
  //   const { name, value, files, dataset } = e.target;
  //   const index = dataset.index ? Number(dataset.index) : null;

  //   if (index !== null) {
  //     setFormData((prev) => {
  //       const updatedSections = [...prev.sections];
  //       updatedSections[index][name] = files ? files[0] : value;
  //       return { ...prev, sections: updatedSections };
  //     });
  //   } else {
  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: files ? files[0] : value,
  //     }));
  //   }
  // };


  const handleChange = (e) => {
    const { name, value, files, dataset } = e.target;
    const index = dataset.index !== undefined ? Number(dataset.index) : null;

    setFormData((prev) => {
      if (index !== null && !isNaN(index)) {
        const updatedSections = [...prev.sections];
        updatedSections[index] = {
          ...updatedSections[index],
          [name]: files ? files[0] : value,
        };
        return { ...prev, sections: updatedSections };
      } else {
        return { ...prev, [name]: files ? files[0] : value };
      }
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("main_heading", formData.main_heading);
      formDataToSend.append("sub_heading", formData.sub_heading);
      formDataToSend.append("description", formData.description);

      if (formData.main_image instanceof File) {
        formDataToSend.append("main_image", formData.main_image);
      }

      // Correct mapping for section fields
      const fieldNames = ["one", "two", "three", "four"];

      formData.sections.forEach((section, index) => {
        const suffix = fieldNames[index]; // Get "one", "two", "three", "four"

        if (section.logo instanceof File) {
          formDataToSend.append(`logo_${suffix}`, section.logo);
        }
        formDataToSend.append(`log_heading_${suffix}`, section.heading);
        formDataToSend.append(`content_${suffix}`, section.content);
      });

      if (contentDetail?.data?.length > 0) {
        const id = contentDetail?.data?.[0]?.id;
        await updateStock({ formData: formDataToSend, id }).unwrap();
        alert("Section updated successfully!");
        refetchContentDetail();
      
      } else {
        await addStock({ formData: formDataToSend }).unwrap();
        alert("Section added successfully!");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Something went wrong");
    }
  };

  if (loadingContent) return <div className="loader"></div>;
  if (error) return <p>Failed to load data</p>;

  return (
    <div>
      <h3>Banner</h3>
      <div className="breadcrum mb-4">
        <p>
          <FontAwesomeIcon icon={faAngleLeft} className="mx-2" />
          <Link to="/home">
            <span>Back</span>
          </Link>
        </p>
      </div>
      <div className="content-wrapper">
        <form onSubmit={handleSubmit}>
          {/* Main Section */}
          <div className="box section-separator">
            <legend>
              <b>Main Section</b>
            </legend>
            <div className="row">
              {[
                { key: "main_heading", label: "Title", type: "text", col: "col-md-6" },
                { key: "sub_heading", label: "Sub Title", type: "text", col: "col-md-6" },
                { key: "description", label: "Description", type: "textarea", col: "col-12" },
              ].map(({ key, label, type, col }) => (
                <div className={`${col} mb-3`} key={key}>
                  <label className="form-label">{label}</label>
                  {type === "textarea" ? (
                    <textarea
                      className="form-control"
                      name={key}
                      value={formData[key]}
                      onChange={handleChange}
                      rows="4"
                    />
                  ) : (
                    <input
                      type="text"
                      className="form-control"
                      name={key}
                      value={formData[key]}
                      onChange={handleChange}
                    />
                  )}
                </div>
              ))}
            </div>




            <div className="row">
              <div className="col-md-6">
                <label className="form-label">Image</label>
                <input
                  type="file"
                  className="form-control"
                  name="main_image"
                  onChange={handleChange}
                />
                {formData.main_image &&
                  typeof formData.main_image === "string" && (
                    <img
                      src={formData.main_image}
                      alt="Preview"
                      width="100"
                      className="mt-2"
                    />
                  )}
              </div>
            </div>
          </div>

          {/* Sections */}
          {formData.sections.map((section, index) => (
            <div className="box section-separator" key={index}>
              <legend>
                <b>Logo {index + 1}</b>
              </legend>
              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">Logo</label>
                  <input
                    type="file"
                    className="form-control mb-4"
                    name="logo"
                    data-index={index}
                    onChange={handleChange}
                  />
                  {section.logo && typeof section.logo === "string" && (
                    <img
                      src={section.logo}
                      alt="Preview"
                      width="100"
                      className="mb-4"
                    />
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">Heading</label>
                  <input
                    type="text"
                    className="form-control mb-4"
                    name="heading"
                    data-index={index}
                    value={section.heading}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Content</label>
                  <input
                    type="text"
                    className="form-control mb-4"
                    name="content"
                    data-index={index}
                    value={section.content}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          ))}

          <button
            type="submit"
            className="btn btn-primary"
            disabled={addLoading || updateLoading}
          >
            {addLoading || updateLoading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AddStockWithSubHeading;
